import * as React from "react";

import { cn } from "@/lib/utils";

/** Rund flaggikon med emoji som reserv om bilden inte kan laddas. */
export function FlagIcon({
  code,
  emoji,
  size = 20,
  className,
}: {
  code: string;
  emoji?: string;
  size?: number;
  className?: string;
}) {
  const [failed, setFailed] = React.useState(false);
  const lower = code.toLowerCase();

  return (
    <span
      aria-hidden="true"
      className={cn(
        "inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-muted ring-1 ring-border",
        className,
      )}
      style={{ width: size, height: size, fontSize: size * 0.8, lineHeight: 1 }}
    >
      {failed || !code ? (
        <span>{emoji ?? "🏳️"}</span>
      ) : (
        <img
          src={`https://flagcdn.com/w80/${lower}.png`}
          alt=""
          aria-hidden
          role="presentation"
          loading="lazy"
          decoding="async"
          width={size}
          height={size}
          className="h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      )}
    </span>
  );
}
